<template>
  <md-selector
      v-model="value"
      :data="handleLanguages"
      max-height="320px"
      :default-value="handleDefaultValue"
      :title="handleTitle"
      large-radius
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
      @confirm="onSelectorConfirm"
      @hide="close"
  >
    <template slot-scope="{ option }">
      <div class="item">
        <template v-if="isHome">
          <img :src="flags[option.key_name]"/>
          <span>{{ option.name }}</span>
        </template>
        <span v-if="isDeposit">{{ option.cur }}</span>
        <span v-if="isWithdraw">{{ option.name }}</span>
        <span v-if="isChangeLang">{{ option.langName }}</span>
        <i/>
      </div>
    </template>
  </md-selector>
</template>

<script>
import { Selector } from 'mand-mobile';

export default {
  name: 'LangSelector',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isHome: {
      type: Boolean,
      default: false
    },
    isDeposit: {
      type: Boolean,
      default: false
    },
    isWithdraw: {
      type: Boolean,
      default: false
    },
    isChangeLang: {
      type: Boolean,
      default: false
    },
    confirmFun: {
      type: Function,
      default: undefined
    },
    langs: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: Object,
      default: () => undefined
    }
  },
  components: {
    [Selector.name]: Selector
  },
  data () {
    return {
      flags: {
        TC: require('./assets/flags/zh.png'),
        VNM: require('./assets/flags/vn.png'),
        USA: require('./assets/flags/us.png')
      }
    };
  },
  computed: {
    ...mapState('publicStore', ['languages']),
    handleLanguages () {
      let array = this.langs.length ? this.langs : this.languages;
      if (this.isDeposit || this.isWithdraw) {
        array = array.filter(item => item.is_currency === 1);
      }
      return array;
    },
    handleDefaultValue () {
      let id;
      if (this.defaultValue) {
        id = this.defaultValue.id;
      } else if (this.isHome || this.isWithdraw) {
        id = localStorage.getItem('nation');
      } else {
        id = this.handleLanguages.length && this.handleLanguages[0].id;
      }
      return id;
    },
    handleTitle () {
      let title = '';
      if (this.isHome || this.isWithdraw) {
        title = this.$t('homeChangeNation');
      }

      if (this.isChangeLang) {
        title = this.$t('homeChooseLang');
      }

      if (this.isDeposit) {
        title = this.$t('chooseCurrency');
      }

      return title;
    }
  },
  methods: {
    ...mapMutations('home', ['setNation']),
    onSelectorConfirm (item) {
      if (this.confirmFun && typeof this.confirmFun === 'function') {
        this.confirmFun(item);
      } else if (this.isHome) {
        this.setNation(item.key_name);
        this.$bus.$emit('afterChangeLanguage', {});
      } else if (this.isChangeLang) {
        this.$i18n.locale = item.key_name;
        localStorage.setItem('lang', item.key_name);
        this.$bus.$emit('afterChangeLanguage', {});
      }
      this.close();
    },
    close () {
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-selector {
  /deep/ .md-popup {
    .md-popup-box {
      border-radius: 12px 12px 0 0;

      .md-popup-title-bar {
        height: 50px;
        margin-bottom: 10px;

        .title-bar-left {
          width: auto;
          padding-left: 20px;
          padding-top: 18px;
          font-size: 16px;
        }

        .title-bar-title {
          padding-top: 18px;

          .title {
            font-size: 16px;
          }
        }

        .title-bar-right {
          width: auto;
          padding-right: 20px;
          padding-top: 18px;
          font-size: 16px;
        }
      }
    }
  }

  /deep/ .md-selector-container {
    .md-cell-item {
      padding: 0;

      .md-cell-item-body {
        min-height: auto;
        padding: 14px 16px !important;

        .md-cell-item-content {

          .item {
            position: relative;
            display: flex;
            align-items: center;

            img {
              width: 24px;
              height: 24px;
              margin-right: 6px;
            }

            span {
              font-family: 'PingFang SC';
              font-size: 16px;
              font-weight: 500;
              line-height: 22px;
              color: #535C66;
            }

            i {
              position: absolute;
              right: 0;
              display: none;
              width: 24px;
              height: 24px;
              background: url("./assets/yesIcon.png") 0 0/100% 100%;
            }
          }
        }
      }

      &.is-selected {
        span {
          color: #2f86f6 !important;
        }

        i {
          display: block !important;
        }
      }
    }
  }
}
</style>
